// 工单相关API接口
import request from '@/utils/request'

/**
 * 分页获取工单列表
 * @param params
 * @param data
 * @returns {*}
 */
export function workorderPage(params,data) {
    return request({
        url: '/workorders/page',
        method: 'post',
        data,
        params
    })
}

/**
 *获取各状态工单数
 * @returns {*}
 */
export function workorderCount() {
    return request({
        url: '/workorders/countStatus_admin',
        method: 'get'
    })
}

/**
 * 受理工单
 * @param id
 * @returns {*}
 */
export function workorderAccept(id) {
    return request({
        url: '/workorders/accept/'+id,
        method: 'put'
    })
}
/**
 * 工单回复
 * @param id
 * @returns {*}
 */
export function workorderAnswer(data) {
    return request({
        url: '/workorders/answer',
        method: 'put',
        data
    })
}
/**
 * 设置工单为待确认
 * @param id
 * @returns {*}
 */
export function workorderSetconfirm(id) {
    return request({
        url: '/workorders/setconfirm/'+id,
        method: 'put'
    })
}
/**
 *获取工单详情
 * @returns {*}
 */
export function workorderDetails(id) {
    return request({
        url: '/workorderdetails/manage/'+id,
        method: 'get'
    })
}
/**
 *获取某个工单
 * @returns {*}
 */
export function getWorkorderById(id) {
    return request({
        url: '/workorders/'+id,
        method: 'get'
    })
}
